import React from 'react';
import { MessageBox, Text } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

/**
 * OverbookingMessage component.
 * @param {Object} props - Component props
 * @param {string} props.tripType - Type of trip: 'departure', 'returns', or undefined for default
 * @returns {React.Element}
 */
const OverbookingMessage = ({ tripType }) => {
  const { t } = useTranslation('passengers');

  const getTitle = () => {
    if (tripType === 'departure') {
      return t('overbooking.title_departure');
    }
    if (tripType === 'returns') {
      return t('overbooking.title_returns');
    }
    return t('overbooking.title');
  };

  return (
    <MessageBox
      iconType="BusStand"
      iconSize="M"
      title={getTitle()}
      hasBorder
      hasShadow={false}
      borderRadius="L"
    >
      <Text size="XS">{t('overbooking.description')}</Text>
    </MessageBox>
  );
};

OverbookingMessage.propTypes = {
  tripType: PropTypes.oneOf(['departure', 'returns']),
};

OverbookingMessage.defaultProps = {
  tripType: undefined,
};

export default OverbookingMessage;
